import React from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import Home from "./pages/Home";
import Studio from "./pages/Studio";
import LoginPage from "./LoginPage";
import Support from "./pages/Support";
import OwnerDashboard from "./pages/OwnerDashboard";
import "./App.css";

function AppInner() {
  const { user } = useAuth();
  
  const [currentPage, setCurrentPage] = React.useState(() => {
    const path = window.location.pathname;
    if (path === "/admin" || path === "/owner") {
      return "owner";
    }
    if (path === "/support") {
      return "support";
    }
    if (path === "/studio") {
      return "studio";
    }
    return "home";
  });

  const [preset, setPreset] = React.useState("Female_Soft_01");

  React.useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === "/admin" || path === "/owner") {
        setCurrentPage("owner");
      } else if (path === "/support") {
        setCurrentPage("support");
      } else if (path === "/studio") {
        setCurrentPage("studio");
      } else {
        setCurrentPage("home");
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = (page) => {
    let path = "/";
    if (page === "owner") path = "/admin";
    else if (page === "support") path = "/support";
    else if (page === "studio") path = "/studio";
    
    window.history.pushState(null, "", path);
    setCurrentPage(page);
  };

  if (!user) return <LoginPage />;

  if (currentPage === "owner") return <OwnerDashboard onBack={() => navigate("home")} />;
  
  if (currentPage === "support") return (
    <Support onBack={() => navigate("home")} />
  );

  if (currentPage === "studio") return (
    <Studio onNavigate={navigate} preset={preset} setPreset={setPreset} />
  );

  return <Home onNavigate={navigate} setPreset={setPreset} />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
